/*
 * @Author: your name
 * @Date: 2021-01-06 08:58:38
 * @LastEditTime: 2021-01-11 08:56:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\store\achievement.js
 */
export default {
  namespaced: true,
  state: () => ({
    achievementsActivity: {
    },
    currentNodeCode:''
  }),
  getters: {},
  mutations: {
    setActivity(state, payload = {}) {
      console.log(payload);
      state.achievementsActivity = payload
    },
    setNodeCode(state, payload = "") {
      state.currentNodeCode = payload
    },
  },
  actions: {}
}
